module.exports = __webpack_public_path__ + "media/icons/ilosc-drzwi-8350924c.png";